import React from 'react';
import './css/main.scss';
import CustomRoute from './CustomRoute';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-quill/dist/quill.snow.css';
import NavigationMenu from './NavigationMenu';

function App() {
  return (
    <>
      <div className="nav-container">
        <NavigationMenu />
      </div>
      <div className="content-container">
        <CustomRoute />
      </div>
    </>
  );
}

export default App;
